import * as React from "react"

import * as styles from "./index.module.scss"

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  variant: "error"
  text: string
}

const Alert: React.FC<Props> = ({
  className,
  variant,
  text,
  ...otherProps
}) => {
  return (
    <div
      className={`${styles.alert} ${styles[variant]} ${className}`}
      {...otherProps}
    >
      <span className={styles.text}>{text}</span>
    </div>
  )
}

export default Alert
